import { CircularProgress } from "@mui/material";
import { UsersEntity } from "entities/Users/UsersEntity";
import RCAUserWithAvatar from "../RCAUserWithAvatar";

export const RCAUserHistoric = ({ userId }: { userId: number }) => {
    const historic = true;
    const { currentUser, loading } = UsersEntity.GetCurrentUser(userId, historic);

    if (loading || !currentUser) {
        return <CircularProgress size={20} color="info" />;
    }

    return (
        <RCAUserWithAvatar
            imageUrl={currentUser?.media?.media_url}
            name={`${currentUser?.first_name} ${currentUser?.last_name}`}
            isObservation
            truncateText={false}
        />
    );
};
